export const TOCCHECKBOX = 'TOCCHECKBOX'